export enum AuthorizationStatus {
  Success = 'Success',
  Decline = 'Decline',
  Offline = 'Offline',
}
